import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: false
})
export class TermsOfUseComponent implements OnInit {
    panelOpenState = false;
    constructor(
        private _location: Location,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        document
            .getElementsByTagName('body')[0]
            .classList.remove('blue-background-active');
    }

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Terms of Use');
    }

    goBack() {
        this._location.back();
    }
}
